import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthOrg } from '../context/AuthOrgContext';
import { hasRolePermission, RolePermission } from '../utils/roles';

interface RoleGuardProps {
    permission: RolePermission;
    children: React.ReactElement;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ permission, children }) => {
    const { user } = useAuthOrg();

    if (!hasRolePermission(user?.userRole, permission)) {
        const fallbackPath = hasRolePermission(user?.userRole, 'viewHome') ? '/home' : '/settings/user-details';
        return <Navigate to={fallbackPath} replace />;
    }

    return children;
};

export default RoleGuard;
